export default __webpack_public_path__ + "static/list-icon-76fe44e6e9a349ce419e8133a0e0781a.png";